import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForeignerComponent } from './foreigner.component';
import { NiceLegalTextModule } from '../../nice-legal-text/nice-legal-text.module';
// import { DialogModule } from '@schoolbelle/common/dialog';

@NgModule({
  declarations: [ForeignerComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    NiceLegalTextModule,
    // DialogModule,
  ],
  exports:[ForeignerComponent],
})
export class ForeignerModule { }
